import { operations } from "types/openapi";
import { api } from "./api";
import { ENDPOINTS } from "services";
import { TRequestValues } from "./authClient/auth/api-utils";

type getWalletsWhitelistOperation = operations["getAll"];
type updateWhitelistOperation = operations["updateWhitelist"];
type addWalletsToWhitelistOperation = operations["addToWhitelist"];
type forbidWalletWhitelistOperation = operations["forbidWallet"];
type allowWalletWhitelistOperation = operations["allowWallet"];

/**
 * Получить список адресов вайт-листа
 */
export const getWalletsWhitelist = async (
  params: Record<string, TRequestValues>
): Promise<getWalletsWhitelistOperation["responses"]["200"]["content"]["*/*"]> => {
  return api.get(ENDPOINTS.walletsWhitelist(), params);
};

/**
 * Обновить настройки белого списка компании
 */
export const updateWhitelist = async (
  companyId: string,
  formData: updateWhitelistOperation["requestBody"]["content"]["application/json"]
): Promise<updateWhitelistOperation["responses"]["200"]> => {
  return api.post(ENDPOINTS.updateWhitelist(companyId), formData);
};

/**
 * Добавить адреса в вайт-лист компании
 */
export const addWalletsToWhitelist = async (
  formData: addWalletsToWhitelistOperation["requestBody"]["content"]["application/json"]
): Promise<addWalletsToWhitelistOperation["responses"]["201"]["content"]["*/*"]> => {
  return api.post(ENDPOINTS.walletsWhitelist(), formData);
};

/**
 * Запретить использование адреса в вайт-листе компании
 */
export const forbidWalletWhitelist = async ({
  companyId,
  walletId,
}: {
  companyId: string;
  walletId: string;
}): Promise<forbidWalletWhitelistOperation["responses"]> => {
  return api.post(ENDPOINTS.forbidWalletWhitelist({ companyId, walletId }));
};

/**
 * Разрешить использование адреса в вайт-листе компании
 */
export const allowWalletWhitelist = async ({
  companyId,
  walletId,
}: {
  companyId: string;
  walletId: string;
}): Promise<allowWalletWhitelistOperation["responses"]> => {
  return api.post(ENDPOINTS.allowWalletWhitelist({ companyId, walletId }));
};
